// MAIN //

const docSpec = {
	content: 'block+'
};


// EXPORTS //

export default docSpec;
